module.exports = __webpack_public_path__ + "img/collection-memoireRingsHalfSetMemories@2x.c5e317e.webp";